import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Header,
  Segment,
  Label,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { TRANSLATION_FILES } from '../constants/translation';

class EditableBox extends Component {
  static propTypes = {
    gridProps: PropTypes.shape({
      stackable: PropTypes.bool,
    }),
    buttonNode: PropTypes.func,
    cancelNode: PropTypes.func,
    color: PropTypes.string,
    isEditing: PropTypes.bool,
    editable: PropTypes.bool,
    onClick: PropTypes.func,
    onCancel: PropTypes.func,
    onEdit: PropTypes.func,
    content: PropTypes.func,
    hideBorder: PropTypes.bool,
    loading: PropTypes.bool,
    newHeader: PropTypes.string,
    isMobile: PropTypes.bool,
    isCollapsible: PropTypes.bool,
    showPreview: PropTypes.bool,
    t: PropTypes.func,
  }
  constructor(props) {
    super(props);
    const isEditing = false || props.isEditing;
    const showPreview = false || props.showPreview;
    this.state = {
      isEditing,
      showPreview,
      hideTab: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.editable) {
      const isEditing = nextProps.isEditing;
      if (isEditing !== undefined) {
        this.setState({ isEditing });
      }
    }
  }
  handleOnConfirm = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (this.props.editable && this.props.onCancel) {
      let isEditing = !this.state.isEditing;
      if (this.props.isEditing !== undefined) {
        isEditing = this.props.isEditing;
      }
      this.setState({ isEditing }, () => {
        if (this.props.isEditing !== undefined) {
          if (isEditing) {
            if (this.props.onClick) {
              this.props.onClick(e);
            }
          } else if (this.props.onEdit) {
            this.props.onEdit(e);
          }
        } else if (!isEditing) {
          if (this.props.onClick) {
            this.props.onClick(e);
          }
        } else if (this.props.onEdit) {
          this.props.onEdit(e);
        }
      });
    } else if (this.props.onClick) {
      this.props.onClick(e);
    }
  }
  handleOnCancel = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (this.props.editable) {
      const isEditing = false;
      this.setState({ isEditing }, () => {
        if (this.props.onCancel) {
          this.props.onCancel(e);
        }
      });
    }
  }
  handleOnCollapseSegment = (e) => {
    e.preventDefault();
    this.setState({ hideTab: !this.state.hideTab });
  }
  render() {
    const { buttonNode, editable, newHeader, isCollapsible, showPreview, t } = this.props;
    const { isEditing, hideTab } = this.state;
    const showButtons = editable && (!newHeader || (newHeader && isCollapsible)) && (isEditing || buttonNode || !showPreview);
    return (
      <div>
        { newHeader &&
          <Header className="new_title" as="h5" attached="top" textAlign="center">
            <Grid>
              {
                this.props.editable ? (
                  <Grid.Row>
                    <Grid.Column width={16} textAlign="center">
                      {this.props.newHeader}
                    </Grid.Column>
                    {
                      !isCollapsible ? (
                        <div>
                          {
                            this.state.isEditing && (this.props.cancelNode ?
                              this.props.cancelNode({
                                isEditing: this.state.isEditing,
                                onClick: this.handleOnCancel,
                              }) : (
                                <Label
                                  as="button"
                                  attached="top left"
                                  style={{
                                    position: 'absolute',
                                    left: '0',
                                    top: '3px',
                                    marginLeft: '0',
                                  }}
                                  color="grey"
                                  content={t('Cancel')}
                                  icon="remove"
                                  onClick={this.handleOnCancel}
                                  disabled={this.props.loading}
                                />
                              ))
                          }
                          {
                            this.props.buttonNode ?
                              this.props.buttonNode({
                                isEditing: this.state.isEditing,
                                onClick: this.handleOnConfirm,
                              }) : (
                                <Label
                                  as="button"
                                  attached="top right"
                                  style={{
                                    right: '0',
                                    top: this.state.isEditing ? '3px' : '0.4em',
                                  }}
                                  color={this.state.isEditing ? 'blue' : null}
                                  content={t(this.state.isEditing ? 'Update' : 'Edit')}
                                  icon={this.state.isEditing ? 'save' : 'edit'}
                                  onClick={this.handleOnConfirm}
                                  disabled={this.props.loading}
                                  className={this.state.isEditing ? '' : 'editable-button-new'}
                                />
                              )
                          }
                        </div>
                      ) : (
                        <Label
                          as="button"
                          attached="top right"
                          icon={hideTab ? 'angle up' : 'angle down'}
                          className="collapse-button"
                          style={{
                            position: 'absolute',
                            right: '0',
                            top: '3px',
                            marginRight: '0',
                            marginTop: '0.5em',
                          }}
                          onClick={this.handleOnCollapseSegment}
                          disabled={this.props.loading}
                        />
                      )
                    }
                  </Grid.Row>
                ) : (
                  <Grid.Row>
                    <Grid.Column width={16} textAlign="center">
                      {this.props.newHeader}
                    </Grid.Column>
                  </Grid.Row>
                )
              }
            </Grid>
          </Header>
        }
        {
          !hideTab ? (
            <Segment
              attached={newHeader !== ''}
              basic={this.props.hideBorder && !this.state.isEditing}
              style={newHeader && isCollapsible ? { padding: '1em' } : {}}
            >
              <Grid {...this.props.gridProps}>
                {
                  showButtons && (
                    <Grid.Row>
                      {
                        this.state.isEditing && (this.props.cancelNode ?
                        this.props.cancelNode({
                          isEditing: this.state.isEditing,
                          onClick: this.handleOnCancel,
                        }) : (
                          <Label
                            as="button"
                            attached="top left"
                            size="small"
                            content={t('Cancel')}
                            icon="remove"
                            onClick={this.handleOnCancel}
                            disabled={this.props.loading}
                          />
                        ))
                      }
                      {
                        this.props.buttonNode && this.props.buttonNode({
                          isEditing: this.state.isEditing,
                          onClick: this.handleOnConfirm,
                        })
                      }
                      {
                        !this.props.buttonNode && !showPreview && (
                          <Label
                            as="button"
                            attached="top right"
                            size="small"
                            color={this.state.isEditing ? 'blue' : null}
                            content={t(this.state.isEditing ? 'Update' : 'Edit')}
                            icon={this.state.isEditing ? 'save' : 'edit'}
                            onClick={this.handleOnConfirm}
                            disabled={this.props.loading}
                            className={this.state.isEditing ? '' : 'editable-button'}
                          />
                        )
                      }
                    </Grid.Row>
                  )
                }
                {
                  this.props.content ?
                    <Grid.Row>
                      <Grid.Column width={16}>
                        {
                          this.props.content({
                            isEditing: this.state.isEditing,
                            onConfirm: this.handleOnConfirm,
                            onCancel: this.handleOnCancel,
                          })
                        }
                      </Grid.Column>
                    </Grid.Row>
                  : null
                }
              </Grid>
            </Segment>
          ) : null
        }
      </div>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.translation)(EditableBox);



// WEBPACK FOOTER //
// ./src/components/EditableBox.jsx